import $ from "jquery";
import { handleCartToggle, refreshFragments } from "../components/cart-ajax";

$(document).on("change", ".cart-addon-checkbox", function () {
  handleCartToggle($(this), {
    getLabelEl: function ($cb) {
      return $('label[for="' + $cb.attr("id") + '"] h3');
    },
    getAddingText: function (info) {
      return "Adding " + info.product_title;
    },
    getAddedText: function (info) {
      return info.product_title;
    },
    getRemovingText: function (info) {
      return "Removing " + info.product_title;
    },
    getRemovedText: function (info) {
      return "Add " + info.product_title;
    },
  });
});

// Trash icon click handler
$(document).on("click", ".remove-cart-item-btn", function () {
  var $btn = $(this);
  var productId = $btn.data("product-id");
  var isBasePlan = $btn.data("is-base-plan") === "1" || $btn.data("is-base-plan") === 1;

  if (isBasePlan) {
    var message = "Removing this item will clear your cart and you will be redirected to restart the enrollment process";
    $("#remove-cart-item-modal .remove-cart-item-message").text(message);
    $("#remove-cart-item-modal .confirm-remove-cart-item")
      .data("product-id", productId)
      .data("is-base-plan", "1");
    $("#remove-cart-item-modal").modal("show");
  } else {
    $("#check_" + productId).prop("checked", false).trigger("change");
  }
});

// Confirmed remove (base plan only)
$(document).on("click", ".confirm-remove-cart-item", function () {
  var $btn = $(this);
  var productId = $btn.data("product-id");

  $btn.prop("disabled", true).text("Removing...");

  $.ajax({
    type: "post",
    url: wc_add_to_cart_params.ajax_url,
    data: {
      action: "ql_woocommerce_ajax_remove_from_cart",
      product_id: productId,
      base_plan: true,
    },
    success: function () {
      window.location.href = EAPLUS_VARS.enroll_now_page_url;
    },
  });
});

// Refresh cart fragments
$(document.body).on(
  "added_to_cart removed_from_cart",
  function (event, fragments) {
    refreshFragments(fragments, "wc_fragments_refreshed");
  }
);

jQuery(function () {
  $(".sh-toggle").on("click", function () {
    $(".sh-content").toggleClass("visually-hidden-sm");
    var $this = $(this);
    if ($(".sh-content").hasClass("visually-hidden-sm")) {
      $this.find(".summary").text("Show order summary");
      $this.find(".arrow-up").removeClass("arrow-up").addClass("arrow-down");
    } else {
      $this.find(".summary").text("Hide order summary");
      $this.find(".arrow-down").removeClass("arrow-down").addClass("arrow-up");
    }
  });
});

jQuery(function () {
  $(".addon-toggle").on("click", function () {
    var $this = $(this);
    $this.siblings(".addon-content").removeClass("visually-hidden-sm");
    $this.addClass("visually-hidden-sm");
  });
});
